import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/home/Hero";
import StatsSection from "@/components/home/StatsSection";
import ElRetoSection from "@/components/home/ElRetoSection";
import MissionSection from "@/components/home/MissionSection";
import ServicesSection from "@/components/home/ServicesSection";
import HowItWorks from "@/components/home/HowItWorks";
import NewsSection from "@/components/home/NewsSection";
import CTASection from "@/components/home/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <StatsSection />
      <ElRetoSection />
      <MissionSection />
      <ServicesSection />
      <HowItWorks />
      <NewsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
